import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
//  tslint:disable-next-line: max-line-length
import { DwDefaultLayoutComponent, DwLoginComponent, DwRouteGuardUtil, DwAuthGuardService, UserProfileComponent, DwPageMenu, DwDefaultFormPage, DwMenuActionType, DevwareMetaDataService, DwMenu, DwOrmDataService, DevwareAdminModule, DwCoreConfig, DwSsoLoginComponent, DwMetaDataRoutingRegistryService, DwRoutingInitDecorator, DwPage404Component } from '@devwareapps/devware-cap';

import { AppMetaDataService } from './meta-data/app-meta-data.service';
import { ConfigService } from 'src/environments/environment';
import { HomePageComponent } from './pages/home-page/home-page.component';



const routes = [

    {
        path: '',
        data: {
            routeId: 'home',
            routeOrder: 1,
            skipMenu: true,
        },
        children: [
            {
                path: '',
                component: HomePageComponent,
                data: {
                    routeId: 'welcome',
                    display: 'Home',
                    iconCssClass: 'fa fa-menu-icon fa-home',
                    routeOrder: 1,
                    hideBreadcrumbParent: true,
                    excludeFromMainMenu: true,
                }
            },
            {
                path: 'user-profile',
                component: UserProfileComponent,
                data: {
                    display: 'User Profile',
                    iconCssClass: 'fa fa-user-edit',
                    excludeFromMainMenu: true,
                    requiresAuthentication: true,
                    showInMenu: true
                },
            },
        ]
    },

    {
        path: 'login',
        component: DwLoginComponent,
        data: {
            routeId: 'login',
            display: 'Login',
            iconCssClass: 'fa fa-menu-icon fa-power-off',
            showInMenu: false,
        }
    },
    {
        path: 'login-sso',
        component: DwSsoLoginComponent,
        data: {
            routeId: 'loginSso',
            display: 'Login (SSO)',
            iconCssClass: 'fa fa-menu-icon fa-power-off',
            showInMenu: false,
        }
    },
    {
    path:"**",
    redirectTo:'',
    data: {
    showInMenu:false,
            },
    component: DwPage404Component
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes,
            {
                preloadingStrategy: PreloadAllModules,
                scrollPositionRestoration: 'enabled'
            }),
        DevwareAdminModule.forRoot()
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
